import styled from "styled-components";

/** Container com estilos para os elementos Skeleton do item histórico */
export const SkeletonItemsWrap = styled.div`
  .skeleton-data-texto {
    margin-bottom: 2px;
    line-height: 1.2;
  }

  .skeleton-hora-texto {
    line-height: 1.2;
    font-weight: 600;
  }

  .skeleton-acao {
    line-height: 1.5;
  }

  .skeleton-codigo {
    line-height: 1.2;
  }

  .skeleton-bottom {
    line-height: 1.2;
  }

  .skeleton-badge {
    padding: 3px 8px;
  }
`;
